import request from 'superagent';
import { STRINGS } from 'config';

const consultation = STRINGS.CONSULTATION_REDUCER;

export const getPublicHealthAlert = healthAlertUrl => dispatch => {
  if (!healthAlertUrl) {
    return null;
  }
  dispatch({ type: consultation.GET_PUBLIC_HEALTH_ALERT_REQUEST });
  return request
    .get(healthAlertUrl)
    .then(response => dispatch({ type: consultation.GET_PUBLIC_HEALTH_ALERT_SUCCESS, payload: response.text }))
    .catch(error => dispatch({ type: consultation.GET_PUBLIC_HEALTH_ALERT_ERROR, payload: error }));
};
